import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ITrack } from '@obvious.tech/constellation'

export const Track = defineEntity('Track', {
  endpoint: 'geolocation/api/Track',
  schema: SNoop<ITrack>(),
})
